import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {HomogenizationOrderListPage} from './homogenization-order-list';
import { TooltipsModule } from 'ionic-tooltips';
import { MomentModule } from 'angular2-moment/moment.module';

@NgModule({
    declarations: [
        HomogenizationOrderListPage,
    ],
    imports: [
        IonicPageModule.forChild(HomogenizationOrderListPage),
        TooltipsModule,
        MomentModule
    ],
})
export class HomogenizationOrderListPageModule { }


// WEBPACK FOOTER //
// ./src/pages/homogenization-order-list/homogenization-order-list.module.ts